import "$styles/index.css"

import components from "$components/**/*.{js,jsx,js.rb,css}"

function setupMobileMenu() {
  const toggle = document.querySelector("[data-menu-toggle]")
  const menu = document.querySelector("[data-mobile-menu]")
  if (!toggle || !menu) return

  const iconOpen = toggle.querySelector("[data-icon-open]")
  const iconClose = toggle.querySelector("[data-icon-close]")

  toggle.addEventListener("click", () => {
    const isHidden = menu.classList.toggle("hidden")
    iconOpen?.classList.toggle("hidden", !isHidden)
    iconClose?.classList.toggle("hidden", isHidden)
  })
}

function setupContactForm() {
  const form = document.querySelector("[data-contact-form]")
  if (!form) return

  const button = form.querySelector("button[type=submit]")
  const successMsg = form.querySelector("[data-status-success]")
  const errorMsg = form.querySelector("[data-status-error]")
  let resetTimer

  form.addEventListener("submit", async (e) => {
    e.preventDefault()
    button.disabled = true
    button.textContent = "Sending..."
    successMsg?.classList.add("hidden")
    errorMsg?.classList.add("hidden")

    try {
      const formData = new FormData(form)
      const payload = Object.fromEntries(formData.entries())

      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })

      if (!response.ok) throw new Error(`Request failed: ${response.status}`)

      successMsg?.classList.remove("hidden")
      form.reset()

      clearTimeout(resetTimer)
      resetTimer = setTimeout(() => successMsg?.classList.add("hidden"), 5000)
    } catch (error) {
      console.error("Form submission error:", error)
      errorMsg?.classList.remove("hidden")
    } finally {
      button.disabled = false
      button.textContent = "Send Message"
    }
  })
}

document.addEventListener("DOMContentLoaded", () => {
  setupMobileMenu()
  setupContactForm()
})
